import GetCookie from "../Components/Hooks/Cookies/GetCookie";
import Data from "../Data/Data.json";

export default function GetBackground() : string{
    return GetCookie(Data.LocalVariable.mode) == 'light'? 'white': '#B0D2F7'
}